var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { cloneElement, isValidElement, } from 'react';
import SvgIcon from '../components/SvgIcon';
/**
 * Returns icon component based on the provided form of the icon. React.cloneElement or `<SvgIcon />` is used to render the icon.
 * @param component Icon to be resolved. Can be either a React element (in form of JSX) or a component passed as an object (ie. Add16)
 * @param iconProps Applied to the svg icon when passed as an object component (Not JSX). For styling you can use sx or any other SvgIconProps.
 * @param defaultIconProps Applied only when cloneElement is used. Use when you want to pass default styles. ie. width, height etc. This should be css styles object.
 * @returns
 */
export function resolveSvgIcon(component, iconProps, defaultIconProps) {
    if (!component) {
        return null;
    }
    if (isValidElement(component) && component != null) {
        // If is valid element, clone it.
        return cloneElement(component, __assign({}, defaultIconProps));
    }
    return React.createElement(SvgIcon, __assign({ component: component }, iconProps));
}
